import ReactPixel from 'react-facebook-pixel'

import type { Environment } from 'config/environment'

import { getFactorialData } from 'modules/core/lib/cookie'

interface FacebookPixelData {
  environment: Environment
  doNotTrack: boolean
  analyticsConsent: boolean | null | undefined
}

function initFacebookPixel({ facebookPixelEnabled }: Environment) {
  const { isFactorial } = getFactorialData() || {}
  if (facebookPixelEnabled && !isFactorial) {
    ReactPixel.init('1373185553014109')
  }
}

export default function runFacebookPixel({
  environment,
  doNotTrack,
  analyticsConsent,
}: FacebookPixelData) {
  if (analyticsConsent === false) return
  if (doNotTrack) return

  initFacebookPixel(environment)
}
